<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-11 class="text-left fw-500">11. Liability and Indemnity</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-11" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Limitation of Liability: RCPAY Virtual Account is not liable for any loss or damage resulting from the Account Holder’s use of the VA, except in cases of gross negligence or wilful misconduct.</li>
                        <li>Indemnification: The Account Holder agrees to indemnify RCPAY Virtual Account against any claims, damages, or losses arising from their breach of these terms or misuse of the VA service.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-11',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>